<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-text class="subtitle-1">
          Current Status: <span class="performance--text">{{ status }}</span>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, 100]
            }"
            @click:row="rowClick"
            class="row-pointer"
          >
            <template v-slot:item.completeDate="{ item }">
              {{ item.completeDate | normalDate }}
            </template>
            <template v-slot:item.attendees="{ item }">
              <overlap-avatars
                :size="25"
                :users="item.attendees"
                :overlap="3"
              ></overlap-avatars>
            </template>
            <template v-slot:item.actions="{}">
              <v-btn text class="light-background" small color="info">
                View
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import OverlapAvatars from "@/components/common/OverlapAvatars";
export default {
  name: "CheckInHistory",
  components: { OverlapAvatars },
  data: () => ({
    clipped: true,
    miniVariant: false,
    headers: [
      { text: "Date", value: "completeDate" },
      { text: "Participants", value: "attendees", sortable: false },
      { text: "Talking Points", value: "talkingPointCount" },
      { text: "Action Items", value: "actionItemCount" },
      { text: "Actions", value: "actions", sortable: false }
    ]
  }),
  computed: {
    status() {
      return this.checkin.archiveDate
        ? "Archived"
        : this.checkin.startDate != null
        ? "Meeting in progress"
        : "Meeting not started";
    },
    items() {
      return this._.orderBy(
        this.history.filter(x => x.completeDate != null),
        ["completeDate"],
        ["desc"]
      );
    },
    ...mapGetters({
      history: "checkin/history",
      checkin: "checkin/checkin",
      checkin_drawer: "checkin/drawer"
    })
  },
  methods: {
    getLink(item) {
      return (
        `/meetings/${item.definitionId}` +
        (item.completeDate ? `/${item.id}` : "")
      );
    },
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin
      });
    },
    rowClick(item) {
      this.$router.push({ path: this.getLink(item) });
    }
  }
};
</script>
